module.exports = __webpack_public_path__ + "static/media/ic_dustbin_unselected.b483c0bb.svg";